import axios from "axios";

const BASE_URL = "https://samsar-demo.dev-api.softweirdo.com";

const SERVER_URL = "https://samsar-demo.dev-api.softweirdo.com"; //for testing

const FILE_URL = "https://samsar-uat-q76vrtgcha-uc.a.run.app";
export interface APIResponse {
  message: string[];
  status: number;
  data: any;
  success: boolean;
}

export const jsoninstance = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
export const jsoninstancenew = axios.create({
  baseURL: SERVER_URL,
  timeout: 3000000,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});
export const jsoninstanceModule = axios.create({
  baseURL: SERVER_URL,
  timeout: 3000000,
  headers: {
    "Content-Type": "application/json",
  },
});

export const jsoninstancefile = axios.create({
  baseURL: FILE_URL,
  timeout: 3000000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export const forminstance = axios.create({
  baseURL: BASE_URL,
  timeout: 150000,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

export const errorHandler = (err: any): APIResponse => {
  const statusCode = err.response?.status;
  const statusresponse = err.response?.data;
  if (statusCode === 401) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    // console.log('window.location.pathname.startsWith("battery-report") : ', window.location);
    if (
      !(
        window.location.hash.split("/")[1] === "battery-report" ||
        window.location.hash.split("/")[1] === "passport" ||
        window.location.hash.split("/")[1] === "battery-report-download"
      )
    ) {
      console.log("redirecting=>.....");
      window.location.href = `${window.location.origin}/login`;
    }
  }
  return {
    message: statusresponse,
    status: statusCode,
    data: null,
    success: false,
  };
};

export const responseHandler = (result: any): APIResponse => {
  return {
    message: [],
    data: result.data,
    status: result.status,
    success: true,
  };
};
